import React, { useState, useEffect } from 'react';
import { useLocation, Link } from 'react-router-dom';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import Icon from '@mui/material/Icon';

import MenuOpenOutlinedIcon from '@mui/icons-material/MenuOpenOutlined';
import MenuOutlinedIcon from '@mui/icons-material/MenuOutlined';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';

import { MDBox } from '../../MDBox';
import { MDInput } from '../../MDInput';
import { Breadcrumbs } from '../../Breadcrumbs';
import { NotificationItem } from '../../Items/NotificationItem';
import {
  navbar,
  navbarContainer,
  navbarRow,
  navbarIconButton,
  navbarDesktopMenu,
  navbarMobileMenu,
} from './styles';
import {
  useMaterialUIController,
  setTransparentNavbar,
  setMiniSidenav,
  setOpenConfigurator,
} from '../../../contexts/layoutContext';
import { useTheme } from '@mui/material';
import { FFTheme } from '../../../assets/theme';
import { FFRoutes } from '../../../routes';

interface DashboardNavbarProps {
  absolute?: boolean;
  light?: boolean;
  isMini?: boolean;
}

export function DashboardNavbar({
  absolute = false,
  light = false,
  isMini = false,
}: DashboardNavbarProps) {
  const [navbarType, setNavbarType] = useState<string>();
  const [controller, dispatch] = useMaterialUIController();
  const {
    miniSidenav,
    transparentNavbar,
    fixedNavbar,
    openConfigurator,
    darkMode,
  } = controller;
  const [openMenu, setOpenMenu] = useState<null | HTMLElement>(null);
  const route = useLocation().pathname.split('/').slice(1);
  const theme = useTheme<FFTheme>();
  let currentPage = route.join('-'); // route[route.length - 1];
  const allCollapseNames = FFRoutes.filter((route) => route.collapse).map(x => x.collapse).flat().map((route) => route!.key);
  const availablePath = [...FFRoutes.map((route) => route.key), ...allCollapseNames];
  if (!availablePath.includes(currentPage)) {
    currentPage = 'claims';
  }

  useEffect(() => {
    if (fixedNavbar) {
      setNavbarType('sticky');
    } else {
      setNavbarType('static');
    }

    // function handleTransparentNavbar() {
    //   setTransparentNavbar(
    //     dispatch,
    //     (fixedNavbar && window.scrollY === 0) || !fixedNavbar
    //   );
    // }

    // window.addEventListener('scroll', handleTransparentNavbar);
    // handleTransparentNavbar();

    // return () => window.removeEventListener('scroll', handleTransparentNavbar);
  }, [dispatch, fixedNavbar]);

  const handleMiniSidenav = () => setMiniSidenav(dispatch, !miniSidenav);
  const handleConfiguratorOpen = () =>
    setOpenConfigurator(dispatch, !openConfigurator);
  const handleOpenMenu = (event: React.MouseEvent<HTMLElement>) =>
    setOpenMenu(event.currentTarget);
  const handleCloseMenu = () => setOpenMenu(null);

  const renderMenu = () => (
    <Menu
      anchorEl={openMenu}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      open={Boolean(openMenu)}
      onClose={handleCloseMenu}
      sx={{ mt: 2 }}
    >
      <NotificationItem icon={<Icon>email</Icon>} title="Check new messages" />
      <NotificationItem
        icon={<Icon>podcasts</Icon>}
        title="Manage Podcast sessions"
      />
      <NotificationItem
        icon={<Icon>shopping_cart</Icon>}
        title="Payment successfully completed"
      />
    </Menu>
  );

  const iconsStyle = ({
    palette: { dark, white, text },
    functions: { rgba },
  }: any) => ({
    color: () => {
      let colorValue = light || darkMode ? white.main : dark.main;

      if (transparentNavbar && !light) {
        colorValue = darkMode ? rgba(text.main, 0.6) : text.main;
      }

      return colorValue;
    },
  });

  return (
    <AppBar
      position={absolute ? 'absolute' : (navbarType as any)}
      color="inherit"
      sx={() => navbar(theme, { transparentNavbar, absolute, light, darkMode })}
    >
      <Toolbar sx={() => navbarContainer(theme)}>
        <MDBox color="inherit" sx={navbarRow(theme, isMini)}>
          <IconButton
            sx={() => navbarDesktopMenu(theme)}
            onClick={handleMiniSidenav}
            size="small"
            disableRipple
          >
            {miniSidenav ? (
              <MenuOpenOutlinedIcon
                fontSize="medium"
                sx={() => iconsStyle(theme)}
              />
            ) : (
              <MenuOutlinedIcon
                fontSize="medium"
                sx={() => iconsStyle(theme)}
              />
            )}
          </IconButton>
          <Breadcrumbs
            icon="home"
            title={currentPage}
            route={currentPage}
            light={light}
          />
        </MDBox>
        {isMini ? null : (
          <MDBox sx={navbarRow(theme, isMini)}>
            <MDBox color={light ? 'white' : 'inherit'}>
              <IconButton
                size="small"
                disableRipple
                color="inherit"
                sx={() => navbarMobileMenu(theme)}
                onClick={handleMiniSidenav}
              >
                {miniSidenav ? (
                  <MenuOpenOutlinedIcon
                    fontSize="medium"
                    sx={() => iconsStyle(theme)}
                  />
                ) : (
                  <MenuOutlinedIcon
                    fontSize="medium"
                    sx={() => iconsStyle(theme)}
                  />
                )}
              </IconButton>
              {/* <IconButton
                size="small"
                disableRipple
                color="inherit"
                sx={() => navbarIconButton(theme)}
                aria-controls="notification-menu"
                aria-haspopup="true"
                onClick={handleOpenMenu}
              >
                <MDBadge
                  badgeContent={11}
                  size="md"
                  color="error"
                  variant="gradient"
                  circular
                  sx={() => iconsStyle(theme)}
                >
                  <NotificationsNoneOutlinedIcon />
                </MDBadge>
              </IconButton> */}
              {renderMenu()}
            </MDBox>
          </MDBox>
        )}
      </Toolbar>
    </AppBar>
  );
}
